import Vue from 'vue'
import VueRouter from 'vue-router'
import TeacherTop from '@/components/pages/teacher/TeacherTop.vue'
import TeacherBase from '@/components/pages/teacher/TeacherBase.vue'
import TeacherSignup from '@/components/pages/teacher/TeacherSignup.vue'
import TeacherMyPage from '@/components/pages/teacher/TeacherMyPage.vue'
import TeacherProfileSetting from '@/components/pages/teacher/TeacherProfileSetting.vue'
import VParentBase from '@/components/pages/parent/VParentBase.vue'
import VParentTop from '@/components/pages/parent/VParentTop.vue'
import VParentSignup from '@/components/pages/parent/VParentSignup.vue'
import VParentMyPage from '@/components/pages/parent/mypage/VParentMyPage.vue'
import VParentProfile from '@/components/pages/parent/mypage/VParentProfile.vue'
import VParentProfileSetting from '@/components/pages/parent/VParentProfileSetting.vue'
import VParentRequests from '@/components/pages/parent/mypage/VParentRequests.vue'
import VStudentProfileSetting from '@/components/pages/parent/mypage/VStudentProfileSetting.vue'
import VParentMessages from '@/components/pages/parent/mypage/VParentMessages.vue'
import VParentOffers from '@/components/pages/parent/mypage/VParentOffers.vue'
import VStudents from '@/components/pages/parent/mypage/VStudents.vue'
import VStudentBase from '@/components/pages/parent/mypage/VStudentBase.vue'
import VSearchTeachers from '@/components/pages/parent/mypage/VSearchTeachers.vue'
import VParentLessons from "@/components/pages/parent/mypage/VParentLessons.vue"
import VParentEditors from '@/components/pages/parent/mypage/VParentEditors.vue'
import VParentEditor from '@/components/pages/parent/mypage/VParentEditor.vue'
import TeacherProfileForm from '@/components/pages/teacher/TeacherProfileForm.vue'
import TeacherMessage from '@/components/pages/teacher/TeacherMessage.vue'
import Requestbox from '@/components/pages/teacher/Requestbox.vue'
import SearchStudents from '@/components/pages/teacher/SearchStudents'
import VEditor from '@/components/organisms/editor/VEditor.vue'
import StudentsInformation from '@/components/pages/teacher/StudentsInformation.vue'
import LessonRequests from '@/components/pages/teacher/LessonRequests.vue'
import LessonSchedules from '@/components/pages/teacher/LessonSchedules.vue'
import TeacherEditors from '@/components/pages/teacher/TeacherEditors.vue'
import TeacherEditor from '@/components/pages/teacher/TeacherEditor.vue'
import VPortal from '@/components/pages/portal/VPortal.vue'
import VContact from '@/components/pages/portal/VContact.vue'
import VPolicy from '@/components/pages/portal/VPolicy.vue'
import VTextBooks from '@/components/pages/portal/VTextBooks.vue'
import VVideoLessons from '@/components/pages/portal/VVideoLessons.vue'
import VApplicationForm from '@/components/pages/lp/VApplicationForm.vue'
import VWhatIsProsense from '@/components/pages/lp/VWhatIsProsense.vue'
import VWhatIsProsense2 from '@/components/pages/lp/VWhatIsProsense2.vue'
import VWhatIsProsense3 from '@/components/pages/lp/VWhatIsProsense3.vue'
import VMinecraft from '@/components/pages/lp/VMinecraft.vue'
import VResult from '@/components/pages/lp/VResult.vue'
import VJuniorHighStudents from '@/components/pages/lp/VJuniorHighStudents.vue'
import VTrialDetails from '@/components/pages/lp/VTrialDetails.vue'
import VArticleBase from '@/components/pages/lp/VArticleBase.vue'
import VChooseLesson from '@/components/pages/lp/VChooseLesson.vue'
import VToLine from '@/components/pages/redirect/VToLine.vue'
import { app } from '@/core/firebase.js'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: VPortal,
    meta: {
      isPublic: true,
      title: 'Prosense トップページ'
    }
  },
  {
    path: '/contact',
    component: VContact,
    name: 'contact',
    meta: {
      isPublic: true,
      title: 'お問い合わせ'
    }
  },
  {
    path: '/policy',
    component: VPolicy,
    name: 'policy',
    meta: {
      isPublic: true,
      title: 'プライバシーポリシー'
    }
  },
  {
    path: '/textbooks',
    component: VTextBooks,
    name: 'textbooks',
    meta: {
      isPublic: true,
      title: 'お子様向けプログラミング用教科書一覧'
    }
  },
  {
    path: '/video-lessons',
    component: VVideoLessons,
    name: 'video-lessons',
    meta: {
      isPublic: true,
      title: 'Prosenseオリジナルビデオ講義シリーズ一覧'
    }
  },
  {
    path: '/teacher/signup',
    component: TeacherSignup,
    meta: { isPublic: true }
  },
  {
    path: '/teacher/profile',
    component: TeacherProfileForm
  },
  {
    path: '/teacher/top',
    component: TeacherTop,
    meta: { isPublic: true }
  },
  {
    path: '/teacher',
    component: TeacherBase,
    meta: { isPublic: true },
    children: [
      {
        path: ':id',
        component: TeacherMyPage
      },
      {
        path: ':id/profile',
        component: TeacherProfileSetting
      },
      {
        path: ':id/students',
        component: StudentsInformation
      },
      {
        path: ':id/search',
        component: SearchStudents
      },
      {
        path: ':id/messages',
        component: TeacherMessage
      },
      {
        path: ':id/requests',
        component: Requestbox
      },
      {
        path: ':id/offers',
        component: LessonRequests
      },
      {
        path: ':id/schedules',
        component: LessonSchedules
      },
      {
        path: ':id/editors',
        component: TeacherEditors
      },
      {
        path: ':id/editor/:index',
        component: TeacherEditor
      }
    ]
  },
  {
    path: '/parent/signup',
    name: "parentSignup",
    component: VParentSignup,
    meta: {
      isPublic: true,
      title: '依頼者アカウント登録'
    }
  },
  {
    path: '/parent/top',
    name: "parentTop",
    component: VParentTop,
    meta: {
      isPublic: true,
      title: 'Prosense 保護者用トップページ'
    }
  },
  {
    path: '/parent/profile',
    name: "parentProfileSetting",
    component: VParentProfileSetting
  },
  {
    path: '/parent',
    component: VParentBase,
    children: [
      {
        path: ':id/',
        name: 'parentMyPage',
        component: VParentMyPage,
        meta: {
          title: 'マイページ'
        }
      },
      {
        path: ':id/profile',
        name: 'parentProfile',
        component: VParentProfile,
        meta: {
          title: 'ユーザー情報'
        }
      },
      {
        path: ':id/student/profile',
        name: 'studentProfileSetting',
        component: VStudentProfileSetting
      },
      {
        path: ':id/students',
        name: 'students',
        component: VStudents
      },
      {
        path: ':id/requests',
        name: 'parentRequests',
        component: VParentRequests
      },
      {
        path: ':id/messages',
        name: 'parentMessages',
        component: VParentMessages,
      },
      {
        path: ':id/search',
        name: 'searchTeachers',
        component: VSearchTeachers
      },
      {
        path: ':id/offers',
        name: 'parentOffers',
        component: VParentOffers
      },
      {
        path: ':id/lessons',
        name: 'parentLessons',
        component: VParentLessons
      },
      {
        path: ':id/editors',
        name: 'parentEditors',
        component: VParentEditors
      },
      {
        path: ':id/editor/:index',
        name: 'parentEditor',
        component: VParentEditor
      },
      {
        path: ':id/:studentId',
        name: 'studentBase',
        component: VStudentBase
      },
    ]
  },
  {
    path: '/editor/:parentId/:teacherId',
    name: 'editor',
    component: VEditor
  },
  {
    path: '/lp',
    name: 'lpBase',
    component: VArticleBase,
    meta: {
      isPublic: true
    },
    children: [
      {
        path: 'application-form',
        name: 'applicationForm',
        component: VApplicationForm,
        meta: {
          isPublic: true,
          title: '無料体験お申し込みフォーム'
        }
      },
      {
        path: 'what-is-prosense',
        name: 'whatIsProsense',
        component: VWhatIsProsense,
        meta: {
          isPublic: true,
          title: 'オンラインプログラミング学習のProsense'
        }
      },
      {
        path: 'what-is-prosense-2',
        name: 'whatIsProsense2',
        component: VWhatIsProsense2,
        meta: {
          isPublic: true,
          title: 'オンラインプログラミング学習のProsense'
        }
      },
      {
        path: 'what-is-prosense-3',
        name: 'whatIsProsense3',
        component: VWhatIsProsense3,
        meta: {
          isPublic: true,
          title: 'オンラインプログラミング学習のProsense'
        }
      },
      {
        path: 'minecraft',
        name: 'minecraft',
        component: VMinecraft,
        meta: {
          isPublic: true,
          title: 'マインクラフトプログラミングのProsense'
        }
      },
      {
        path: 'result',
        name: 'result',
        component: VResult,
        meta: {
          isPublic: true,
          title: 'スコア画面'
        }
      },
      {
        path: 'junior-high-students',
        name: 'juniorHighStudents',
        component: VJuniorHighStudents,
        meta: {
          isPublic: true,
          title: '中学生からでも遅くない！習い事のススメ'
        }
      },
      {
        path: 'trial-details',
        name: 'trialDetails',
        component: VTrialDetails,
        meta: {
          isPublic: true,
          title: '無料体験について'
        }
      },
      {
        path: 'choose-lesson',
        name: 'chooseLessonArticle',
        component: VChooseLesson,
        meta: {
          isPublic: true,
          title: '【パパママ必見！】子どもの習い事はこれでキマリ！'
        }
      }
    ]
  },
  {
    path: '/redirect/to-line',
    name: 'toLine',
    component: VToLine,
    meta: {
      isPublic: true,
      title: 'LINEへ転送しています'
    }
  }
]


const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => !record.meta.isPublic)) {
    app.auth().onAuthStateChanged(function (user) {
      if (user) {
        next()
      } else {
        const dist = to.path.startsWith('/teacher') ? '/teacher/top' : '/parent/top'
        next({ path: dist })
      }
    })
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = 'Prosense'
  }
})

export default router